<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    full-height
    full-height-no-scroll
    content-class="osk-more-details-dialog"
    @update:model-value="emits('update:modelValue', $event)"
  >
    <div class="osk-more-details-dialog__wrapper">
      <div class="osk-more-details-dialog__content">
        <UikitLoaderInner v-if="pending" />

        <HomeGenderPage
          v-if="moreDetailsData?.items"
          :data="moreDetailsData.items"
          :home-banner-id="(homeBannerId as string)"
          is-more-details
        />
      </div>
    </div>
  </UikitDialog>
</template>

<script setup lang="ts">
import { useApi } from '~/restAPI';
import { Home } from '~/restAPI/Home';

import { CountryIds } from '~/types/constants';

const props = defineProps<{
  modelValue: boolean
  link?: string
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
  (e: 'success'): void,
}>();

const { createApiInstance } = useApi();
const homeApi = createApiInstance(Home);

const homeBannerId = computed(() => props.link && props.link.slice(props.link.lastIndexOf('/') + 1));

const {
  data: moreDetailsData,
  error,
  pending,
  execute: getData,
} = useLazyAsyncData(() => homeApi.getBannerContent({
  id: homeBannerId.value as string,
  pageNumber: 0,
  countryId: CountryIds.Russia,
  productFiltrationEnabled: true,
  withStories: true,
  blockListVersion: 2,
}).then((res) => {
  const resData = res.data?.data;

  return resData;
}), { immediate: false });

watch(() => props.modelValue, async (value) => {
  if (value && homeBannerId.value) {
    getData();
  }

  if (!value) {
    moreDetailsData.value = null;
  }
});
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-more-details-dialog {
  @include font-body-all;

  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;

  @include media-query(lg-and-up) {
    width: 504px !important;
    padding-bottom: 0 !important;
  }

  .osk-dialog__close {
    top: 22px;
    right: 16px !important;

    @include media-query(lg-and-up) {
      top: 44px;
      right: 50px !important;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    @include media-query(lg-and-up) {
      padding-top: 100px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    // padding: 0 $indent-medium;
    position: relative;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @include media-query(lg-and-up) {
      // padding: 0 52px 16px;
    }
  }

  &__footer {
    padding: $indent-medium;

    @include media-query(lg-and-up) {
      padding: $indent-medium 52px 52px;
    }
  }
}
</style>
